/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const DAI_ZERO_REVIEW_CROP_FIELDS = gql`
  fragment DAIZeroReviewCropFields on DAIZeroReviewCrop {
    source
    cropId
    upc
    imageUrl
    minX
    minY
    maxX
    maxY
    excluded
    replacementUpc
    verified
    created
    inDaiZero
    verificationSource
  }
`
